export default "__VITE_ASSET__QBcKL8QS__"